import axios from "@/axios";
import {getDateWithFormat} from "@/utils";
import i18n from "@/i18n";

const getReservations = (params) => {
    let body = getBody(params);
    return axios
        .post("/GetReservas", body)
};

const getContratosLop = (params) => {
    let path = `/GetContratosLop${getQuery(params)}`;
    return axios
        .get(path);
};

const getContratosRac = (params) => {
    let body = getBody(params);
    return axios
        .post("/GetContratos", body)
};

const getCotizaciones = (params) => {
    const body = getBody(params);
    body.RutEmpresa = body.rut;
    delete body.rut;
    return axios
        .post("/GetCotizacionesEmpresa", body);
};

const getQuotesRac = (params) => {
    const body = getBody(params);
    return axios
        .post("/GetCotizaciones", body);
};

const getDocumentsRac = (params) => {
    const body = {
        PersoRut: params.rutEmpresa,
        pagina: params.currentPage,
        registros: params.perPage,
        Negocio: "R"
    }

    if (params.inputNumero) {
        body['ctaCteNroDocto'] = params.inputNumero;
    }
    if (params.daterange[0]) {
        body['FechaDesde'] = getDateWithFormat(params.daterange[0], "YYYY-MM-DD");
        body['FechaHasta'] = getDateWithFormat(params.daterange[1], "YYYY-MM-DD");
    }
    return axios
        .post("/ConsultaDocumentos", body);
};

const getDocumentos = (params) => {
    let path = `/GetDTELop${getQuery(params)}`
    return axios
        .get(path);
};

const getReferences = (params) => {
    let body = getBody(params);
    return axios
        .post(`/${i18n.t("lease.reference.getReferences")}`, body)
};

const downloadCotizacion = (numero) => {
    let path = `/PdfCotizacion/${numero}`;
    return axios
        .get(path);
}

const getQuery = (params) => {
    let query = `?Pagina=${params.currentPage}&Registros=${params.perPage}&RutEmpresa=${params.rutEmpresa}`;
    if (params.inputNumero) {
        query = query + `&NumeroContrato=${params.inputNumero}`;
    }
    if (params.daterange) {
        query =
            query +
            `&FechaDesde=${getDateWithFormat(
                params.daterange[0],
                "YYYY-MM-DD"
            )}&FechaHasta=${getDateWithFormat(params.daterange[1], "YYYY-MM-DD")}`;
    }
    return query;
};
const getBody = (params) => {
    const body = {
        rut: params.rutEmpresa,
        pagina: params.currentPage,
        registros: params.perPage,
        RutContacto: parseInt(params.RutContacto.split('-')[0])
    }

    if (params.inputNumero) {
        body['numero'] = params.inputNumero;
    }
    if (params.daterange) {
        body['fechaDesde'] = getDateWithFormat(params.daterange[0], "YYYY-MM-DD");
        body['fechaHasta'] = getDateWithFormat(params.daterange[1], "YYYY-MM-DD");
    }
    return body;
}

export default {
    getReservations,
    getContratosLop,
    getContratosRac,
    getCotizaciones,
    getQuotesRac,
    getDocumentsRac,
    getDocumentos,
    getReferences,
    downloadCotizacion
};
